/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Vp_Blocked_ExcessiveInputs */



/**
* | output |
* | --- |
* | "These victory points add up to more than this table can award ({max})." |
*
* @param {Vp_Blocked_ExcessiveInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vp_blocked_excessive = /** @type {((inputs: Vp_Blocked_ExcessiveInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vp_Blocked_ExcessiveInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ces VP dépassent ce que cette table peut attribuer (${i?.max}).`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Estos VP suman más de lo que esta mesa puede otorgar (${i?.max}).`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Estes VP somam mais do que esta mesa pode atribuir (${i?.max}).`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Questi VP superano quanto questo tavolo può assegnare (${i?.max}).`)
	return /** @type {LocalizedString} */ (`These victory points add up to more than this table can award (${i?.max}).`)
});